import { useTranslation } from 'react-i18next'

import translations from '@translationKeys'

import TruncateLines from '@components/TruncateLines'
import { Box, Divider, Typography } from '@mui/material'

import {
  FilterAllContainer,
  FilterOptionCheckbox,
  FilterOptionContainer,
  FilterOptionLabel,
  FilterSectionContainer,
} from './index.styles'

const FilterSection = ({
  title,
  options,
  handleSelect,
  handleSelectAll,
  selectedIds,
}: {
  title: string
  selectedIds: string[]
  handleSelect: (id: string) => void
  handleSelectAll?: (ids: string[]) => void
  options: { id: string; label: string; color?: string }[]
}) => {
  const { t } = useTranslation()

  const isAllSelected = !options.find(({ id }) => !selectedIds.includes(id))

  const onSelectAll = () => {
    let optionsToSelect = options.map(({ id }) => id)
    if (!isAllSelected) {
      optionsToSelect = optionsToSelect.filter(id => !selectedIds.includes(id))
    }
    handleSelectAll?.(optionsToSelect)
  }
  return (
    <Box mb="10px">
      <FilterSectionContainer>
        <Typography variant="caption">{title}</Typography>
        {!!handleSelectAll && (
          <FilterAllContainer>
            <FilterOptionLabel variant="body1">
              <TruncateLines lines={2}>{t(translations.SELECT_ALL_LABEL)}</TruncateLines>
            </FilterOptionLabel>

            <FilterOptionCheckbox checked={isAllSelected} onChange={onSelectAll} />
          </FilterAllContainer>
        )}
      </FilterSectionContainer>

      {title && <Divider sx={{ margin: '10px 0' }} />}
      {options.map(option => (
        <FilterOptionContainer key={option.id}>
          <FilterOptionLabel variant="body1">
            <TruncateLines lines={2}>{option.label}</TruncateLines>
          </FilterOptionLabel>

          <FilterOptionCheckbox
            checked={selectedIds.includes(option.id)}
            onChange={() => handleSelect(option.id)}
            $color={option.color}
          />
        </FilterOptionContainer>
      ))}
    </Box>
  )
}

export default FilterSection
